import { render, staticRenderFns } from "./foodAdd.vue?vue&type=template&id=3a636cdf&"
import script from "./foodAdd.vue?vue&type=script&lang=js&"
export * from "./foodAdd.vue?vue&type=script&lang=js&"
import style0 from "./foodAdd.vue?vue&type=style&index=0&id=3a636cdf&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports